export enum NavigationTarget {
  CALENDAR_PAGE = 'CALENDAR_PAGE',
  SERVICE_PAGE = 'SERVICE_PAGE',
  BOOKING_FORM = 'BOOKING_FORM',
}
